import { render, staticRenderFns } from "./IpInput.vue?vue&type=template&id=5227c4d4&"
import script from "./IpInput.vue?vue&type=script&lang=js&"
export * from "./IpInput.vue?vue&type=script&lang=js&"
import style0 from "./IpInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports